import { fetchMFCodesUncached, fetchUFCodesUncached } from "../../api";
import { ValidationError } from "../../errors";
import { flattenSortCodes } from "../datasources/sortCodes";
import { loadDataIntoSheet } from "../workbook";

export const tabulateMasterFormat = async (): Promise<void> => {
  try {
    const mfResult = await fetchMFCodesUncached();
    if (!mfResult.success) {
      throw mfResult.error;
    }
    const mfCodes = mfResult.data || [];
    if (!mfCodes || mfCodes.length === 0) {
      throw new ValidationError("No MasterFormat setup data found");
    }
    const flatMFData = flattenSortCodes(mfCodes, "mf");
    await loadDataIntoSheet(flatMFData, "MasterFormat", { adminTable: true });
  } catch (error) {
    console.error("Error with MasterFormat ETL:", error);
    throw error;
  }
};

export const tabulateUniformat = async (): Promise<void> => {
  try {
    const ufResult = await fetchUFCodesUncached();
    if (!ufResult.success) {
      throw ufResult.error;
    }
    const ufCodes = ufResult.data || [];
    if (!ufCodes || ufCodes.length === 0) {
      throw new ValidationError("No Uniformat setup data found");
    }
    const flatUFData = flattenSortCodes(ufCodes, "uf");
    await loadDataIntoSheet(flatUFData, "Uniformat", { adminTable: true });
  } catch (error) {
    console.error("Error with Uniformat ETL:", error);
    throw error;
  }
};
